import { render, staticRenderFns } from "./FormElementsPage.vue?vue&type=template&id=42512afd&"
import script from "./FormElementsPage.vue?vue&type=script&lang=ts&"
export * from "./FormElementsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports